import {Component, OnInit} from '@angular/core';

import {File} from 'app/models/file';
import {FilesService} from 'app/services/files.service';
import {AssetSortingType} from 'app/models/asset-sorting-type';
import {FileFilterList} from 'app/models/file-filter-list';
import {GoogleTagManagerService} from '../../services/google-tag-manager.service';

@Component({
    selector: 'app-files',
    templateUrl: './files.component.html',
    styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {

    files: File[];
    sortingType: AssetSortingType;
    lastEvaluatedKey: any;
    firstSort: Boolean;


    constructor(
      private filesService: FilesService,
      private gtmService: GoogleTagManagerService,

    ) {
        this.firstSort = true;
    }

    onTileSort(sortingType): void {
        this.sortingType = sortingType;
        this.getAll();
        if (!this.firstSort) {
          this.gtmService.pushEvent(`Sort by - ${sortingType.name}`);
        }
        this.firstSort = false;

    }

    ngOnInit() {
        this.getAll();
    }
    onDiscard() {
        this.files = [];
    }

    getNext() {
        this.getAll(this.lastEvaluatedKey);
    }

    getAll(lastEvaluatedKey?: string): void {
        this.filesService
        .getAll(lastEvaluatedKey, (this.sortingType)?this.sortingType.id:undefined)
        .subscribe(data => {
           this.files = this.files && lastEvaluatedKey ?
                this.files.concat(data.Items) : data.Items;
            this.lastEvaluatedKey = data.LastEvaluatedKey;
        });
    }
}
